(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.product-comparison');
    if (!section) return;

    var toggle = section.querySelector('[data-comparison-toggle]');
    var tabs = section.querySelectorAll('[data-comparison-tab]');
    var cards = section.querySelectorAll('[data-comparison-card]');
    var indicator = section.querySelector('[data-comparison-indicator]');

    function activate(side) {
      tabs.forEach(function(tab) {
        var isCurrent = tab.dataset.comparisonTab === side;
        tab.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        tab.classList.toggle('product-comparison__toggle-tab--active', isCurrent);
      });

      cards.forEach(function(card) {
        card.classList.toggle('product-comparison__card--visible', card.dataset.comparisonCard === side);
      });

      toggle.classList.toggle('is-right', side === 'old');
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activate(this.dataset.comparisonTab);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
